// api/deviceService.ts
interface FetchDevicesParams {
  service: string; // base URL
  endpoint: {
    path: string;
    query: string;
    requires_authentication?: boolean;
  };
  environmentToken?: string; // API token from environment
}


export async function fetchDevices(data: FetchDevicesParams): Promise<any> {
  const { service, endpoint, environmentToken } = data;

  // Construct full URL
  const url = `${service}${endpoint.path}`;

  // Prepare headers - only include Authorization if authentication is required
  const headers: Record<string, string> = {};
  
  if (endpoint.requires_authentication && environmentToken) {
    headers.Authorization = `Bearer ${environmentToken}`;
  }

  const response = await fetch(url, {
    method: "GET",
    headers
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch devices: ${response.status} ${response.statusText}`);
  }

  const responseData = await response.json();

  return {
    status: response.status,
    data: responseData
  };

}
